import { render, staticRenderFns } from "./rendererRichText.vue?vue&type=template&id=b1dbb656&scoped=true"
import script from "./rendererRichText.vue?vue&type=script&lang=js"
export * from "./rendererRichText.vue?vue&type=script&lang=js"
import style0 from "./rendererRichText.vue?vue&type=style&index=0&id=b1dbb656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dbb656",
  null
  
)

export default component.exports